import React from 'react';
import { Menu, Badge } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

function LeftMenu(props) {
  const user = useSelector(state => state.user);
  const chatRooms = user?.chatData?.chatRooms;

  const newChatCount = chatRooms?.reduce((acc, room) => {
    const visitedAt = room?.memberVisitedMap?.[user?.userData?._id] || 0;
    return acc + room?.messages?.filter(msg => {
      return new Date(msg.createdAt) > new Date(visitedAt);
    })?.length
  }, 0);

  return (
    <Menu mode={props.mode} className='menugroup' disabledOverflow="true">
      <Menu.Item key="main_board" className='menuitem'>
        <Link to="/">
          <img src="/images/home.png" alt="home" />
          <p>프로젝트</p>
        </Link>
      </Menu.Item>
      {/* <Menu.Item key="equip_list_history" className='menuitem'>
        <Link to="/user/cart">
            <Badge count={user.userData && user.userData.cart.length} offset={[-20, 7]}>
              <img src="/images/cart.png" alt="cart"/>
            </Badge>
          <p>사야할것</p>
        </Link>
      </Menu.Item> */}
      <Menu.Item key="members" className='menuitem'>
        <Link to="/members">
          <Badge count={user.userData?.candidates?.length} offset={[-3, 0]}>
            <img src="/images/friends.png" alt="friends" />
          </Badge>
          <p>멤버</p>
        </Link>
      </Menu.Item>
      <Menu.Item key="chat" className='menuitem'>
        <Link to={`/chat_list`}>
          <Badge count={newChatCount} offset={[-3, 0]}>
            <img src="/images/chat.png" alt="chat" />
          </Badge>
          <p>채팅</p>
        </Link>
      </Menu.Item>
      <Menu.Item key="others" className='menuitem'>
        <Link to="/profile">
          <img src={user.userData?.image} className='rounded-circle' alt="ellipsis" />
          <p>내정보</p>
        </Link>
      </Menu.Item>
      {/* <SubMenu title={<span>Blogs</span>}>
      <MenuItemGroup title="Item 1">
        <Menu.Item key="setting:1">Option 1</Menu.Item>
        <Menu.Item key="setting:2">Option 2</Menu.Item>
      </MenuItemGroup>
      <MenuItemGroup title="Item 2">
        <Menu.Item key="setting:3">Option 3</Menu.Item>
        <Menu.Item key="setting:4">Option 4</Menu.Item>
      </MenuItemGroup>
    </SubMenu> */}
    </Menu>
  )
}

export default LeftMenu